// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"90181db3","547":"90181db3","6353":"90181db3"}[chunkId] + ".chunk.css";
};